import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Form extends PureComponent {
  static propTypes = {
    initialValues: PropTypes.shape({}).isRequired,
    onSubmit: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
    validateValues: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    validateValues: null
  };

  state = {
    values: this.props.initialValues,
    errors: {},
    touched: {}
  };

  onChange = async (e, validate = () => {}) => {
    // e.preventDefault(); // not sure if needed yet
    const { value, name, type, checked } = e?.target || e;
    const isCheckbox = type === 'checkbox';
    const result = (await validate(value)) || undefined;

    this.setState(({ values, errors }) => ({
      // eslint-disable-next-line react/no-unused-state
      lastUpdated: Date.now(),
      values: {
        ...values,
        [name]: isCheckbox ? checked : value
      },
      errors: {
        ...errors,
        [name]: result
      }
    }));
  };

  onTouched = e => {
    const { name } = e.target;
    this.setState(({ touched }) => ({
      touched: {
        ...touched,
        [name]: true
      }
    }));
  };

  onSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const { values } = this.state;

    onSubmit(values);
  };

  // TODO: Implement checkbox validate rules?? How do we show this??
  // TODO: Add form validation func - this would replace field validate func (since it wont be needed)
  // we ignore boolean values when checking for values

  render() {
    const { children, initialValues, validateValues } = this.props;
    const { values, errors, touched } = this.state;
    const isValid = (validateValues || Object.keys(initialValues)).every(x => {
      const hasValue = x
        .split('.')
        .filter(y => (typeof initialValues[y] === 'boolean' ? null : y))
        .filter(Boolean)
        .reduce((acc, y) => acc[y], values);
      const hasError = x.split('.').reduce((acc, y) => acc[y], errors);

      return hasValue && !hasError;
    });

    return (
      <form onSubmit={this.onSubmit}>
        {typeof children === 'function'
          ? children({
              values,
              errors,
              touched,
              onChange: this.onChange,
              onTouched: this.onTouched,
              isValid
            })
          : children}
      </form>
    );
  }
}
